import { ref } from 'vue'
import { useRoute } from 'vue-router'
import { FormWrapper } from '@/wrappers'
import type { TaskRegister, FormData, FormInfo, DataFile, RequestType } from '@/interfaces'

export function useTaskRegister() {

    const baseForm: FormData = {
        name: null,
        date: new Date().toLocaleDateString("en-NL").split("/").join("-"),
        task: {
            startTime: null,
            endTime: null,
            description: null,
            result: null,
            assignedBy: "Ikzelf",
            notes: null
        }
    };

    const route = useRoute();
    const wrapper = new FormWrapper<TaskRegister>("task-register");

    const request = ref<RequestType<FormData>>({
        isLoading: false,
        error: null,
        response: null,
        data: baseForm
    });

    const file = ref<File|null>(null);
    const info = ref<FormInfo>();
    const forms = ref<TaskRegister[]>([]);
    const id = ref<string|string[]>(route.params.id);

    async function addForm(): Promise<void> {
        request.value = {...request.value, error: null, response: null, isLoading: !request.value.isLoading};

        await wrapper.addForm(getData()).then((data) => request.value.response = data.message)
            .catch((err) => request.value.error = err.response.data.message);

        if (!request.value.error) {
            file.value = null;

            request.value.data.task = {
                startTime: request.value.data.task.endTime,
                endTime: null,
                description: null,
                result: null,
                assignedBy: "Ikzelf",
                notes: null
            };
        }

        request.value.isLoading = !request.value.isLoading;
    }

    async function getForm(): Promise<void> {
        request.value.isLoading = !request.value.isLoading;

        await wrapper.getForm(id.value).then((data) => request.value.data = data)
            .catch((err) => request.value.error = err.response.data.message);

        request.value.isLoading = !request.value.isLoading;
    }

    async function getIndex(): Promise<void> {
        request.value.isLoading = !request.value.isLoading;

        await wrapper.getForms().then((data) => forms.value = data);

        request.value.isLoading = !request.value.isLoading;
    }

    async function getInfo(): Promise<void> {
        request.value.isLoading = !request.value.isLoading;

        await wrapper.getInfo().then((data) => info.value = data);

        request.value.isLoading = !request.value.isLoading;
    }

    function getData(): DataFile {
        return {
            file: file.value,
            data: JSON.stringify(request.value.data)
        }
    }

    return {
        info,
        file,
        forms,
        request,
        addForm,
        getForm,
        getInfo,
        getIndex
    };
}